// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 58 ? "quill" : chunkId) + "." + {"58":"2b0b7401929c0127","453":"2f36ea1ef8fb3c22","491":"0840884f5a0ec027","713":"7591f2ac7a5fbad0"}[chunkId] + ".js";
};